import DeleteConfirmation from "components/modal/delete-confirmation"
import InputTypeAtRest from "components/asset-management/portfolios/controls/input-type-at-rest"
import AssetSelectionDetailed from "components/asset-management/portfolios/controls/asset-selection-detailed"
import UserAccess from "components/asset-management/portfolios/controls/user-access"
import UserAccessAtRest from "components/asset-management/portfolios/controls/user-access-at-rest"
import UserAccessHover from "components/asset-management/portfolios/controls/user-access-hover"

export default {
  AssetSelectionDetailed,
  DetailedStub: () => { return null },
  DeleteConfirmation,
  InputTypeAtRest,
  UserAccess,
  UserAccessAtRest,
  UserAccessHover
}
